// PostHog loader stub (vendor snippet)
// prettier-ignore
!function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}p||((p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",p.onerror=function(){p=null},(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r));var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],Object.defineProperty(u,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e}}),Object.defineProperty(u.people,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(){return u.toString(1)+".people (stub)"}}),o="vu fu pu gu bu init Hu zu qu ju Gu Xa Bu Qu Du eh ih nh sh rh oh capture getExtension Uu cu hh calculateEventProperties uh register register_once register_for_session unregister unregister_for_session gh Nu dh getFeatureFlag getFeatureFlagPayload getFeatureFlagResult getAllFeatureFlags isFeatureEnabled reloadFeatureFlags updateFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey displaySurvey cancelPendingSurvey canRenderSurvey canRenderSurveyAsync mh identify setPersonProperties unsetPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset yh shutdown setIdentity clearIdentity get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException addExceptionStep captureLog startExceptionAutocapture stopExceptionAutocapture loadToolbar get_property getSessionProperty fh Xu createPersonProfile setInternalOrTestUser ph wu opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing get_explicit_consent_status is_capturing clear_opt_in_out_capturing Ju debug Ya Os getPageViewId captureTraceFeedback captureTraceMetric Ru".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);

const {
  customer,
  product: pageProduct,
  pageview: pageviewProperties = {},
  ...liquidGlobals
} = JSON.parse(document.getElementById('analytics-globals')?.textContent || '{}')
const SESSION_STORAGE_KEY = 'analytics_session'
const EXPERIMENTS_STORAGE_KEY = 'analytics_experiments'
const PAGE_TYPE_STORAGE_KEY = 'analytics_page_type'
const PRODUCT_FORMS =
  'device-product-form, body-product-form, body-belt-product-form, body-stand-product-form, body-panel-product-form, subscription-product-form'
// Cart lines that aren't products the customer chose.
const UNTRACKED_HANDLES = ['shipping-protection']

// product_category / product_line by product handle. The sheet's enums are closed, so
// unlisted handles send no category or line. Keep in sync with the checkout pixel's copy.
const PRODUCT_TAXONOMY = {
  'hair/essential': [
    'laser-hair-growth-system-essential',
    'essential-bundle',
    'essential-best-seller-bundle',
    'essential-eye-mask-bundle',
    'essential-face-mask-bundle',
    'essential-neck-chest-mask-bundle',
  ],
  'hair/professional': [
    'laser-hair-growth-system-professional',
    'laser-hair-growth-system-professional-pre-rebrand',
    'pro-bundle',
    'pro-eye-mask-bundle',
    'pro-neck-chest-mask-bundle',
    'professional-best-seller-bundle',
    'professional-face-mask-bundle',
    'professional-face-mask-pro-bundle',
    'professional-trio',
    'irestore-duo-pro-sculpt-belt',
    'pro-apex-panel-hair-helmet-bundle',
  ],
  'hair/elite': [
    'laser-hair-growth-system-elite',
    'elite-bundle',
    'elite-best-seller-bundle',
    'elite-eye-mask-bundle',
    'elite-face-mask-bundle',
    'elite-face-mask-pro-bundle',
    'elite-neck-chest-mask-bundle',
    'elite-hair-body-bundle',
    'elite-apex-panel-hair-helmet-bundle',
    'irestore-duo-elite-apex-1500',
  ],
  'hair/revive': [
    'revive-growth-accelerator-kit',
    'revive-max-growth-kit',
    'revive-plus-growth-accelerator-kit',
    'revive-plus-max-growth-kit',
    'revive-growth-activator-serum',
    'revive-thickening-shampoo',
    'revive-thickening-conditioner',
    'revive-thickening-duo-shampoo-conditioner',
    'revive-brow-lash-duo',
    'revive-eyebrow-enhancing-serum',
    'revive-eyelash-enhancing-serum',
  ],
  hair: ['scalpstim-derma-roller', 'anti-thinning-conditioner'],
  'supplement/revive': ['revive-hair-growth-formula', 'revive-advanced-hair-growth-formula', 'revive-biotin-vitamin-gummies'],
  'skin/illumina': [
    'illumina-led-face-mask',
    'illumina-led-eye-mask',
    'illumina-led-neck-chest-mask',
    'illumina-led-duo',
    'illumina-led-trio',
    'illumina-led-eye-mask-duo',
    'illumina-youthful-eye-bundle',
  ],
  skin: [
    'laser-face-mask-pro',
    'laser-face-mask-pro-duo',
    'laser-led-trio-pro',
    'irestore-duo-face-mask-sculpt-belt',
    'advanced-retinol-serum',
    'am-pm-duo',
    'growth-factor-peptide-firming-cream',
    'vitamin-c-brightening-serum',
    'renew-anti-aging-eye-cream',
    'renew-anti-aging-face-serum',
    'renew-calming-facial-spray',
    'renew-hydrating-foam-cleanser',
    'renew-red-light-essentials-kit',
  ],
  'body/apex': [
    'apex-half-body-led-panel',
    'irestore-apex-pro-studio-bundle',
    'irestore-apex-pro-full-body-bundle',
    'irestore-apex-elite-studio-bundle',
    'irestore-apex-elite-full-body-bundle',
    'pro-apex-panel-face-mask-bundle',
    'elite-apex-panel-face-mask-bundle',
  ],
  'body/sculpt': ['sculpt-led-belt', 'sculpt-belt-duo'],
  'body/flex': ['flex-led-belt'],
  accessory: [
    '3-year-warranty-essential',
    '3-year-warranty-pro',
    '4-year-warranty-additional-2-years-ess',
    '4-year-warranty-additional-2-years-pro',
    '4-year-warranty-additional-2-years-elite',
    'laser-face-mask-pro-warranty',
    'sculpt-belt-warranty',
    'flex-belt-warranty',
    'illumina-eye-mask-warranty',
    'illumina-face-mask-warranty',
    'illumina-neck-chest-mask-warranty',
    'illumina-led-duo-warranty',
    'illumina-led-trio-warranty',
    'rechargeable-battery-pack',
    'rechargeable-battery-pack-for-irestore-laser-device-elite',
    'rechargeable-battery-pack-for-irestore-laser-device-professional-essential',
    'irestore-professional-soft-carry-case',
    'device-cleaning-solution',
    'illumina-glow-stand',
    'apex-visionguard-glasses',
    'apex-body-panel-stands-system',
    'sculpt-belt-universal-power-bank',
    'light-activated-mist',
  ],
}
const TAXONOMY_BY_HANDLE = Object.fromEntries(
  Object.entries(PRODUCT_TAXONOMY).flatMap(([key, handles]) => handles.map((handle) => [handle, key.split('/')]))
)

// ponytail: assumes the store currency is USD (100% of orders are); convert here if a non-USD market launches
const toUsd = (cents) => (cents == null ? undefined : cents / 100)
// Storage access itself throws when the browser blocks it, so look it up inside the try.
const readStorage = (storage, key) => {
  try {
    return JSON.parse(window[storage].getItem(key))
  } catch {
    return null
  }
}
const writeStorage = (storage, key, value) => {
  try {
    window[storage].setItem(key, JSON.stringify(value))
  } catch {}
}
const capture = (event, properties) => window.posthog.capture(event, properties)

// The sheet's product property block. Prices are in cents, as Shopify returns them.
const getProductBlock = ({ productId, variantId, sku, title, handle, price, compareAtPrice }) => {
  const [category, line] = TAXONOMY_BY_HANDLE[handle] || []
  return {
    product_id: productId == null ? undefined : String(productId),
    variant_id: variantId == null ? undefined : String(variantId),
    sku: sku || undefined,
    product_title: title,
    product_category: category,
    product_line: line,
    price_usd: toUsd(price),
    compare_at_price_usd: compareAtPrice > price ? toUsd(compareAtPrice) : undefined,
    discount_pct: compareAtPrice > price ? Math.round((1 - price / compareAtPrice) * 100) : undefined,
    is_bundle: /bundle|duo|trio|kit/.test(handle || ''),
  }
}

const getCartItemBlock = (item) =>
  getProductBlock({
    productId: item.product_id,
    variantId: item.variant_id,
    sku: item.sku,
    title: item.product_title,
    handle: item.handle,
    price: item.price,
  })

const getCartBlock = (cart) =>
  cart && {
    cart_value_usd: toUsd(cart.total_price),
    line_item_count: cart.items.length,
    cart_product_categories: [...new Set(cart.items.map((item) => TAXONOMY_BY_HANDLE[item.handle]?.[0]).filter(Boolean))],
    discount_usd: toUsd(cart.total_discount),
    discount_code: cart.discount_codes?.filter((discount) => discount.applicable).map((discount) => discount.code).join(',') || undefined,
  }

const getConsentState = () => {
  const privacy = window.Shopify?.customerPrivacy
  if (!privacy) return undefined
  const analytics = privacy.analyticsProcessingAllowed()
  const marketing = privacy.marketingAllowed()
  if (analytics && marketing) return 'granted'
  return analytics || marketing ? 'partial' : 'denied'
}

// PostHog only keeps UTM params as session entry properties, so keep the ad IDs from the
// session's landing URL, keyed on PostHog's session ID.
const getSessionGlobals = (props) => {
  let session = readStorage('localStorage', SESSION_STORAGE_KEY) || {}

  if (props.$session_id && session.id !== props.$session_id) {
    const params = new URL(props.$current_url || location.href).searchParams
    session = {
      id: props.$session_id,
      campaign_id: params.get('utm_id') || undefined,
      ad_id: params.get('ad_id') || undefined,
    }
    writeStorage('localStorage', SESSION_STORAGE_KEY, session)
  }

  return { campaign_id: session.campaign_id, ad_id: session.ad_id }
}

// Intelligems loads async, so events fired before it's ready go without assignments.
const getExperimentAssignments = () => {
  try {
    const user = window.igData?.user
    if (!user) return []
    return user
      .getExperiments()
      .map(({ id, name }) => ({ id, name, variant: user.getTestGroup(id) }))
      .filter(({ variant }) => variant)
  } catch {
    return []
  }
}

const getExperimentVariants = () => {
  const assignments = getExperimentAssignments()
  return assignments.length ? Object.fromEntries(assignments.map(({ id, variant }) => [id, variant.id])) : undefined
}

// Global properties from the event plan's Properties tab. Acquisition and device values
// PostHog already records ($session_entry_*, $device_type, $viewport_width) aren't duplicated.
const getGlobals = (props) => ({
  ...liquidGlobals,
  ...getSessionGlobals(props),
  consent_state: getConsentState(),
  experiment_variants: getExperimentVariants(),
})

// Checkout can't read theme settings, so hand the sale name to the checkout pixel in a cookie.
document.cookie = `analytics_sale_name=${encodeURIComponent(liquidGlobals.sale_name || '')}; path=/; SameSite=Lax`

// product_viewed, collection_viewed and lp_viewed are PostHog's $pageview with these added.
const referrerPageType = readStorage('sessionStorage', PAGE_TYPE_STORAGE_KEY) || undefined
writeStorage('sessionStorage', PAGE_TYPE_STORAGE_KEY, liquidGlobals.page_type)

const pageviewExtras = {
  ...pageviewProperties,
  ...(pageProduct && {
    ...getProductBlock(pageProduct),
    inventory_state: pageProduct.inventoryState,
    is_subscription_offer_shown: pageProduct.isSubscriptionOfferShown,
  }),
  referrer_page_type: referrerPageType,
}

window.posthog.init('phc_9Y3HlpgzS7buqtDqpb1lB1x8Dg3e7eYF67SPMOIAhpX', {
  api_host: 'https://ap.irestorelaser.com', // your managed reverse proxy domain
  ui_host: 'https://us.posthog.com', // necessary because you're using a proxy, this way links will point back to PostHog properly
  defaults: '2026-05-30',
  person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
  before_send: (event) => {
    if (!event) return event
    Object.assign(event.properties, getGlobals(event.properties))
    if (event.event === '$pageview') Object.assign(event.properties, pageviewExtras)
    return event
  },
})

// Logged-in customers. customer_state and lifetime_order_count are person properties, so PostHog
// attaches them to every event from this person. Email is the distinct ID so the same person
// matches across login, email capture and checkout.
if (customer?.email) window.posthog.identify(customer.email, customer)

// product_variant_selected: radio changes inside a product form. The form's own change handler
// runs first (it's closer to the input), so its hidden variant ID is already updated.
document.addEventListener('change', (event) => {
  const input = event.target
  if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return
  const form = input.closest(PRODUCT_FORMS)
  if (!form) return

  const variantId = form.querySelector('input[name="id"]')?.value || input.value || form.getAttribute('variant-id')
  const prices = pageProduct?.variantPrices || {}
  const basePrice = prices[pageProduct?.variantId]
  capture('product_variant_selected', {
    product_id: pageProduct && String(pageProduct.productId),
    variant_id: variantId || undefined,
    variant_label: input.labels?.[0]?.innerText.trim().replace(/\s+/g, ' ') || input.value,
    option_name: input.name,
    price_delta_usd: prices[variantId] != null && basePrice != null ? toUsd(prices[variantId] - basePrice) : undefined,
  })
})

// add_to_cart: every add goes through /cart/add, so read the request and response there.
// The response has the full line (product data); the request has the quantity added.
const getAddedQuantities = (body) => {
  let payload = body
  if (body instanceof FormData) payload = { id: body.get('id'), quantity: body.get('quantity') }
  else if (typeof body === 'string') {
    try {
      payload = JSON.parse(body)
    } catch {
      return {}
    }
  }
  const items = payload?.items || [payload]
  return Object.fromEntries(items.filter((item) => item?.id).map((item) => [String(item.id), Number(item.quantity) || 1]))
}

const getAddLocation = () => {
  if (window.HybridCart?.isOpen) return 'cart_recs'
  if (liquidGlobals.page_type === 'pdp' || liquidGlobals.page_type === 'lp') return liquidGlobals.page_type
  return 'quick_add'
}

const originalFetch = window.fetch
window.fetch = async (...args) => {
  const response = await originalFetch(...args)
  try {
    const [resource, options] = args
    const url = resource instanceof Request ? resource.url : String(resource)
    if (response.ok && url.includes('/cart/add')) {
      const quantities = getAddedQuantities(options?.body)
      const addLocation = getAddLocation()
      response
        .clone()
        .json()
        .then((data) => {
          for (const item of data.items || [data]) {
            if (UNTRACKED_HANDLES.includes(item.handle)) continue
            capture('add_to_cart', {
              ...getCartItemBlock(item),
              quantity: quantities[String(item.variant_id)] || quantities[String(item.id)] || 1,
              add_location: addLocation,
            })
          }
        })
        .catch(() => {})
    }
  } catch {}
  return response
}

// cart_viewed (drawer) and cart_item_removed come from Hybrid Cart's state. It boots from a
// deferred loader, so wait for it rather than assuming it's there.
// ponytail: polls for ~10s, switch to a Hybrid Cart ready event if it ever dispatches one
const whenHybridCart = (callback, attempts = 40) => {
  if (window.HybridCart?.subscribe) callback(window.HybridCart)
  else if (attempts > 0) setTimeout(() => whenHybridCart(callback, attempts - 1), 250)
}

whenHybridCart((hybridCart) => {
  hybridCart.subscribe(
    (cart) => cart.isOpen,
    (isOpen, cart) => {
      if (isOpen) capture('cart_viewed', { ...getCartBlock(cart.data), surface: 'drawer' })
    }
  )

  // The store updates the cart in place, so watch lastUpdated and keep a snapshot of the lines.
  let previousItems
  hybridCart.subscribe(
    (cart) => cart.lastUpdated,
    (_, cart) => {
      const data = cart.data
      if (!data) return
      if (previousItems) {
        const currentKeys = new Set(data.items.map((item) => item.key))
        for (const item of previousItems) {
          if (currentKeys.has(item.key) || UNTRACKED_HANDLES.includes(item.handle)) continue
          capture('cart_item_removed', {
            ...getCartItemBlock(item),
            quantity: item.quantity,
            cart_value_usd_after: toUsd(data.total_price),
          })
        }
      }
      previousItems = data.items.map((item) => ({ ...item }))
    }
  )
})

// email_captured: Klaviyo forms. Identify here so the anonymous browsing joins to the person.
window.addEventListener('klaviyoForms', (event) => {
  if (event.detail?.type !== 'submit') return
  const email = event.detail.metaData?.$email?.trim().toLowerCase()
  // Don't switch an already-identified person (e.g. a logged-in customer) to a different email.
  if (email && window.posthog.get_property('$user_state') !== 'identified') {
    window.posthog.identify(email, { email }, { customer_state: 'prospect' })
  }
  capture('email_captured', { capture_source: 'klaviyo', form_id: event.detail.formId })
})

// Octane quizzes. quiz_result_cta_clicked is autocapture on [data-quiz-cta] / [data-result-cta].
let quizStartedAt
const getQuizId = () => document.querySelector('.octane-ai-quiz')?.dataset.quizId
const startQuiz = () => {
  if (quizStartedAt) return
  quizStartedAt = Date.now()
  capture('quiz_started', { quiz_id: getQuizId() })
}
document.addEventListener('octane.quiz.rendered', startQuiz)
document.addEventListener('octane.quiz.questionLoaded', startQuiz)
document.addEventListener('octane.quiz.completed', (event) => {
  capture('quiz_completed', {
    quiz_id: getQuizId(),
    question_count: Object.keys(event.detail?.answers || {}).length,
    completion_time_ms: quizStartedAt ? Date.now() - quizStartedAt : undefined,
  })
  // The quiz section's own completed handler (registered first) has already pointed the
  // result CTA at the recommended product.
  const resultUrl = document.querySelector('[data-quiz-cta], [data-result-cta]')?.getAttribute('href')
  capture('quiz_result_viewed', {
    quiz_id: getQuizId(),
    recommended_product_handle: resultUrl?.match(/\/products\/([^/?#]+)/)?.[1],
  })
})

// experiment_exposed: once per Intelligems assignment on this device.
const trackExperimentExposures = () => {
  const seen = readStorage('localStorage', EXPERIMENTS_STORAGE_KEY) || {}
  let changed = false
  for (const { id, name, variant } of getExperimentAssignments()) {
    if (seen[id] === variant.id) continue
    seen[id] = variant.id
    changed = true
    capture('experiment_exposed', {
      experiment_id: id,
      experiment_name: name,
      variant_id: variant.id,
      variant_name: variant.name,
      source: 'intelligems',
    })
  }
  if (changed) writeStorage('localStorage', EXPERIMENTS_STORAGE_KEY, seen)

  // Checkout can't read Intelligems either, so hand assignments to the checkout pixel in a cookie.
  // This sends everything seen because Intelligems only reports experiments targeting the current
  // page, while assignments persist across pages.
  if (Object.keys(seen).length) {
    document.cookie = `analytics_experiment_variants=${encodeURIComponent(JSON.stringify(seen))}; path=/; SameSite=Lax`
  }
}
window.addEventListener('ig:ready', trackExperimentExposures)
trackExperimentExposures()
